import React, { Component } from 'react';
import { Button, Card, Form, Input, Select, Table } from 'antd';
import { connect } from 'react-redux';

import '../../tabRow.less';
import { queryDeleteAttachment } from '@api/pub/attachment';

import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFileTable';
import { BackBtn } from '@comm/BackBtn';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chapters: [{ id: 0 }],
      renewalFiles: [{ id: 0 }],
      chaptersCount: 1,
      renewalFilesCount: 1,
      delFiles: [],
    };
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    handSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { data } = this.props;
    if (data.chapters && data.chapters.length) {
      data.chapters.map(item => {
        item.id = item.uuid;
        return 1;
      });
      this.setState({
        chapters: data.chapters,
        chaptersCount: data.chapters.length,
      });
    }
    if (data.renewalFiles && data.renewalFiles.length) {
      data.renewalFiles.map(item => {
        item.id = item.uuid;
        return 1;
      });
      this.setState({
        renewalFiles: data.renewalFiles,
        renewalFilesCount: data.renewalFiles.length,
      });
    }
  }

  // 提交
  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const { chapters, renewalFiles } = this.state;
    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };

    this.props.form.validateFields((err, values) => {
      if (!err) {
        chapters.map(item => {
          item.companyUuid = values[`companyUuid${item.id}`];
          item.company = values[`company${item.id}`];
          item.seal = values[`seal${item.id}`];
          item.type = values[`type${item.id}`];

          delete params[`companyUuid${item.id}`];
          delete params[`company${item.id}`];
          delete params[`seal${item.id}`];
          delete params[`type${item.id}`];
          return item;
        });
        renewalFiles.map(item => {
          item.name = values[`name${item.id}`];
          item.files = values[`files${item.id}`];
          delete params[`name${item.id}`];
          delete params[`files${item.id}`];
          return item;
        });
        params.chapters = chapters;
        params.renewalFiles = renewalFiles;
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            });
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  // 公司变化，记录公司名称
  handleCompanyChange = (id, value, option) => {
    this.props.form.setFieldsValue({
      [`company${id}`]: option ? option.props.children : '',
    });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  addChapters = () => {
    const { chapters, chaptersCount } = this.state;
    chapters.push({ id: chaptersCount });
    this.setState({
      chapters,
      chaptersCount: chaptersCount + 1,
    });
  };

  deleteChapters = id => {
    const { chapters } = this.state;
    this.setState({
      chapters: chapters.filter(item => item.id !== id),
    });
  };

  addEffects = () => {
    const { renewalFiles, renewalFilesCount } = this.state;
    renewalFiles.push({ id: renewalFilesCount });
    this.setState({
      renewalFiles,
      renewalFilesCount: renewalFilesCount + 1,
    });
  };

  deleteEffects = id => {
    const { renewalFiles } = this.state;
    this.setState({
      renewalFiles: renewalFiles.filter(item => item.id !== id),
    });
  };

  chaptersColumns = () => {
    const { getFieldDecorator } = this.props.form;
    const { chapters } = this.state;
    const arr = [
      {
        title: '*用章公司',
        dataIndex: 'companyUuid',
        key: 'companyUuid',
        width: '35%',
        render: (text, record) => {
          getFieldDecorator(`company${record.id}`, {
            initialValue: record.company,
          });
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`companyUuid${record.id}`, {
                rules: [{ required: true, message: '请选择用章公司' }],
                initialValue: record.companyUuid,
              })(
                <CompanySearch
                  companyName={record.company}
                  companyUuid={record.companyUuid}
                  onChange={(value, option) => this.handleCompanyChange(record.id, value, option)}
                  {...this.props}
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '*用章类型',
        dataIndex: 'type',
        key: 'type',
        width: '30%',
        render: (text, record) => {
          let defaultType;
          switch (text) {
            case 0:
              defaultType = '0';
              break;
            case 1:
              defaultType = '1';
              break;
            case 2:
              defaultType = '2';
              break;
            default:
              break;
          }
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`type${record.id}`, {
                rules: [{ required: true, message: '请选择用章类型' }],
                initialValue: defaultType,
              })(
                <Select placeholder="请选择用章类型">
                  <Option key="0">公章</Option>
                  <Option key="1">合同章</Option>
                  <Option key="2">法人章</Option>
                </Select>,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '是否外借',
        dataIndex: 'seal',
        key: 'seal',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`seal${record.id}`, {
                rules: [{ required: true, message: '请选择是否外借' }],
                initialValue: record.seal ? `${record.seal}` : '0',
              })(
                <Select>
                  <Option key="0">否</Option>
                  <Option key="1">是</Option>
                </Select>,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '45px' }}>
              {chapters && chapters.length > 1 ? (
                <Link onClick={() => this.deleteChapters(record.id)}>删除</Link>
              ) : null}
            </div>
          );
        },
      },
    ];

    if (!chapters || chapters.length === 1) {
      arr.pop();
    }
    return arr;
  };

  renewalFilesColumns = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { renewalFiles } = this.state;

    const arr = [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '18%',
        render: (text, record) => {
          const filesArr = getFieldValue(`files${record.id}`) || [];
          let defaultName = filesArr[0] ? filesArr[0].name : '';
          const index = defaultName.indexOf('.');
          defaultName = defaultName.slice(0, index);
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.id}`, {
                rules: [{ required: true, message: '请填写文件名称' }],
                initialValue: record.name || defaultName || null,
              })(<Input placeholder="请输入文件名称" />)}
            </FormItem>
          );
        },
      },
      {
        title: '*附件',
        dataIndex: 'files',
        key: 'files',
        width: '22%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`files${record.id}`, {
                rules: [{ required: true, message: '请上传附件' }],
                initialValue: record.files || [],
              })(
                <UploadFile
                  type="ghost"
                  fileList={record.file}
                  isPreview
                  onRemove={this.fileRemove}
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '45px' }}>
              {renewalFiles && renewalFiles.length > 1 ? (
                <Link onClick={() => this.deleteEffects(record.id)}>删除</Link>
              ) : null}
            </div>
          );
        },
      },
    ];
    if (!renewalFiles || renewalFiles.length <= 1) {
      arr.pop();
    }
    return arr;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { chapters, renewalFiles } = this.state;
    const { isSubmitting, data } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 18 },
      },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            保存申请
          </Button>
        </div>
        <Card bordered={false} style={{ width: '100%' }}>
          <FormItem {...formItemLayout} label="续证资料名称">
            <Link to={`/administrative/material/info/${data.documentUuid}`}>
              {data.documentName}
            </Link>
          </FormItem>
          <FormItem {...formItemLayout} label="新资料名称">
            <Link to={`/administrative/material/info/${data.newDocumentUuid}`}>
              {data.newDocumentName}
            </Link>
          </FormItem>
          <FormItem {...formItemLayout} label="用章类别">
            {getFieldDecorator('chapters')(
              <div>
                <Table
                  columns={this.chaptersColumns()}
                  dataSource={chapters}
                  pagination={false}
                  rowKey="id"
                  rowClassName="tabRow"
                />
                <Button onClick={this.addChapters} style={{ width: '100%', borderStyle: 'dashed' }}>
                  +添加用章
                </Button>
              </div>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="申请附件">
            {getFieldDecorator('renewalFiles')(
              <div>
                <Table
                  columns={this.renewalFilesColumns()}
                  dataSource={renewalFiles}
                  pagination={false}
                  rowKey="id"
                  rowClassName="tabRow"
                />
                <Button onClick={this.addEffects} style={{ width: '100%', borderStyle: 'dashed' }}>
                  +添加附件
                </Button>
              </div>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="申请说明">
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请填写申请说明' }],
              initialValue: data.reason || null,
            })(<TextArea style={{ minHeight: 32 }} rows={4} placeholder="请填写申请说明" />)}
          </FormItem>
          <FormItem label="申请人" {...formItemLayout}>
            {getFieldDecorator('crName')(<span>{this.props.accountInfo.userName}</span>)}
          </FormItem>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/administrative/material/renewal/FormBase.js